export const FILL_RATE_PRODUCT_DIFFERENCES_DETAIL_TAB = 'detalle'

export const FILL_RATE_PRODUCT_DIFFERENCES_TABS = [
  {
    value: FILL_RATE_PRODUCT_DIFFERENCES_DETAIL_TAB,
    label: 'Detalle',
    icon: 'info'
  }
]
